import { safeId } from "@otto-ec/otto-components-utils/utils/safeId";
import { componentsScope } from "../../../../common/utils/logger.js";
import type { Props } from "../SheetV1.types.js";
import type { DefineComponentProps } from "../../../../common/runtime/types.js";

export const sheetScope = /*           */ componentsScope.scope("sheet-v1");

export const sheetProps = [
  "id",
  "url",
  "base64Url",
  "open",
  "allowedErrorStatusCodes",
  "adaptiveAlignment",
  "extraData",
  "headline",
  "headlineLevel",
  "hideHeader",
  "hideCloseButton",
  "fullHeight",
  "ocAriaLabel",
  "noContentPadding",
  "discardContentOnInactive",
  "disableTracking",
] as const satisfies (keyof Props)[];

/**
 *
 */
export const autoIdPrefix = "auto-";

/**
 *
 *
 *
 *
 *
 *
 *
 *
 */
export function applyProps(sheet: HTMLOcSheetV1Element, config: Partial<Props>): string {
  Object.entries(config).forEach(([key, value]) => {
    /*                                                     */
    sheet[key] = value;
  });

  /*                             */
  sheet.id ??= safeId(undefined, autoIdPrefix);
  /*                                            */
  sheet.setAttribute("id", sheet.id);

  return sheet.id;
}

export const props = {
  open: { type: "Boolean" },
  headline: {},
  headlineLevel: { type: "Number", attribute: "headline-level" },
  id: { reflect: true },
  url: {},
  base64Url: { attribute: "base64-url" },
  hideHeader: { type: "Boolean", attribute: "hide-header" },
  hideCloseButton: { type: "Boolean", attribute: "hide-close-button" },
  hideBackButton: { type: "Boolean", attribute: "hide-back-button" },
  fullHeight: { type: "Boolean", attribute: "full-height" },
  adaptiveAlignment: { attribute: "adaptive-alignment" },
  maxWidthCentered: { attribute: "max-width-centered" },
  ocAriaLabel: { attribute: "oc-aria-label" },
  noContentPadding: { type: "Boolean", attribute: "no-content-padding" },
  discardContentOnInactive: { type: "Boolean", attribute: "discard-content-on-inactive" },
  allowedErrorStatusCodes: { type: "Array", attribute: "allowed-error-status-codes" },
  disableCloseInteractions: { type: "Boolean", attribute: "disable-close-interactions" },
  disableTracking: { type: "Boolean", attribute: "disable-tracking" },
  extraData: { type: "Object", attribute: "extra-data" },
} as const satisfies DefineComponentProps<Props>;
